export default function useNoTemplating(string) {
  if (!string) {
    return null;
  }
  return string.includes('___') ? string.replace(/___.*$/, '') : string;
}
